// @flow

import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Route, Switch} from 'react-router';
import {ConnectedRouter} from 'react-router-redux';
import {bindActionCreators} from 'redux';
import * as AuthActions from './actions/auth';
import {history} from './index';
import Dashboard from './routes/Dashboard/Dashboard';
import ForgotPassword from './routes/ForgotPassword/ForgotPassword';
import Login from './routes/Login/Login';
import NoMatch from './routes/NoMatch/NoMatch';
import ResetPassword from './routes/ResetPassword/ResetPassword';

class App extends Component {
  render() {
    return (
      <ConnectedRouter history={history}>
        <Switch>
          <Route exact path="/" component={Dashboard}/>
          <Route exact path="/login" component={Login}/>
          <Route exact path="/forgot-password" component={ForgotPassword}/>
          <Route exact path="/reset-password" component={ResetPassword}/>
          <Route component={NoMatch}/>
        </Switch>
      </ConnectedRouter>
    );
  }
}

function mapStateToProps(state) {
  return {
    auth: state.auth
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(AuthActions, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(App);



// WEBPACK FOOTER //
// ./src/App.js